/**
 *
 * @module creditCard
 *
 */

import Check from 'check-types';
import CreditCardType from './creditCardType';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    number,
    nonEmptyString,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class CreditCard
 *
 */
export default class CreditCard {

    /**
     *
     * @param {Number} expirationMonth
     * @param {Number} expirationYear
     * @param {String} name
     * @param {String} securityCodeDecrypted
     * @param {Object} type
     * @throws {InvalidArgumentException}
     *
     */
    constructor(expirationMonth, expirationYear, name, securityCodeDecrypted, type) {

        const errorMessage = {
            ctor: 'CreditCard(expirationMonth, expirationYear, name, securityCodeDecrypted, type)',
            get expirationMonth() {
                return `${this.ctor} expirationMonth should be a Number`;
            },
            get expirationYear() {
                return `${this.ctor} expirationYear should be a Number`;
            },
            get name() {
                return `${this.ctor} name should be a String with length`;
            },
            get securityCodeDecrypted() {
                return `${this.ctor} securityCodeDecrypted should be a String with length`;
            },
            get type() {
                return `${this.ctor} type should be a non-empty Object`;
            }
        };

        number(expirationMonth, errorMessage.expirationMonth, InvalidArgumentException);
        number(expirationYear, errorMessage.expirationYear, InvalidArgumentException);
        nonEmptyString(name, errorMessage.name, InvalidArgumentException);
        nonEmptyString(securityCodeDecrypted, errorMessage.securityCodeDecrypted, InvalidArgumentException); // eslint-disable-line
        nonEmptyObject(type, errorMessage.type, InvalidArgumentException);

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.expirationMonth = expirationMonth;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.expirationYear = expirationYear;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.name = name;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.securityCodeDecrypted = securityCodeDecrypted;

        /**
         *
         * @access public
         * @TODO Check if type should be passed in as an instance of CreditCardType or if composing it is ok
         * @type {SDK.Services.Commerce.CreditCardType}
         *
         */
        this.type = new CreditCardType(type);

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/creditCard.js